import {
  Configuration,
  ChosenOptionList,
  TunnelConfiguration,
  ConfigToSendInterface,
  ChosenOption,
  CurrentNegativeDefaultOptionModel,
  CurrentNegativeDefaultOptionFinishEquipment,
} from '@greenkub-fronts/shared/interface';

export const initConfig = (configurations: Configuration[]) => {
  const initiatedConfig: TunnelConfiguration[] = [
    {
      currentModel: null,
      currentEquipment: null,
      currentFinish: null,
      quantity: 0,
      currentSurface: 0,
      currentOptions: [],
      currentCustomProduct: [],
      currentNegativeDefaultOptionModel: [],
      currentNegativeDefaultOptionFinishEquipment: [],
    },
  ];

  configurations.forEach((config: Configuration, index: number) => {
    initiatedConfig[index] = {
      currentModel: config.chosenStudioList.studio.model || null,
      currentEquipment: config.chosenStudioList.studio.equipment || null,
      currentFinish: config.chosenStudioList.studio.finish || null,
      quantity: config.chosenStudioList.chosenStudio.length || 0,
      currentSurface: config.chosenStudioList.chosenStudio[0].surface,
      currentOptions: config.chosenOptionLists.map(
        (chosenOptionList: ChosenOptionList) => ({
          option: chosenOptionList.catalogue,
          qty: chosenOptionList.chosenOption.length,
        })
      ),

      currentCustomProduct: config.chosenCustomOptionLists.map(
        (chosenCustomOptionList: any) => ({
          name: chosenCustomOptionList.name,
          desc: chosenCustomOptionList.description,
          price:
            chosenCustomOptionList.totalPriceWithVat /
            chosenCustomOptionList.chosenCustomOption.length,
          quantity: chosenCustomOptionList.chosenCustomOption.length,
        })
      ),
      currentNegativeDefaultOptionModel: [],
      currentNegativeDefaultOptionFinishEquipment: [],
    };

    const idsSeen1: string[] = [];
    // @ts-ignore
    initiatedConfig[index].currentNegativeDefaultOptionModel =
      config.defaultOptionModelList.chosenOption
        .map((chosenOption: ChosenOption) => {
          if (!idsSeen1.includes(chosenOption.odooId)) {
            idsSeen1.push(chosenOption.odooId);
            let count = 0;
            for (const defOp of config.defaultOptionModelList.chosenOption) {
              if (defOp.odooId == chosenOption.odooId) {
                count--;
              }
            }
            return {
              option: chosenOption,
              quantity: count,
            };
          } else {
            return undefined;
          }
        })
        .filter((element: CurrentNegativeDefaultOptionModel | undefined) => {
          return element !== undefined;
        });

    const idsSeen2: string[] = [];
    // @ts-ignore
    initiatedConfig[index].currentNegativeDefaultOptionFinishEquipment =
      config.defaultOptionFinishEquipmentList.chosenOption
        .map((option: ChosenOption) => {
          if (!idsSeen2.includes(option.odooId)) {
            idsSeen2.push(option.odooId);
            let count = 0;
            for (const defOp of config.defaultOptionFinishEquipmentList
              .chosenOption) {
              if (defOp.odooId === option.odooId) {
                count--;
              }
            }
            return {
              option: option,
              quantity: count,
            };
          } else {
            return undefined;
          }
        })
        .filter(
          (
            element: CurrentNegativeDefaultOptionFinishEquipment | undefined
          ) => {
            return element !== undefined;
          }
        );
  });

  return initiatedConfig;
};

export const formatToMinimalistConfig = (
  configurations: TunnelConfiguration[]
) => {
  const configsToSend: ConfigToSendInterface[] = [];

  configurations.forEach((config, index) => {
    configsToSend[index] = {
      quantity: 1,
      surface: 0,
      model: null,
      finish: null,
      equipment: null,
      options: [],
      custom_products: [],
      negative_default_option_models: [],
      negative_default_options_finish_equipment: [],
    };

    if (config.currentModel?.id) {
      configsToSend[index].model = config.currentModel.id;
    } else {
      throw new Error(
        'Aucun model choisi, impossible de sauvegarder vos choix'
      );
    }

    if (config.quantity) {
      configsToSend[index].quantity = config.quantity;
    }

    if (config.currentSurface) {
      configsToSend[index].surface = config.currentSurface;
    }

    if (config.currentFinish?.id) {
      configsToSend[index].finish = config.currentFinish.id;
    } else {
      throw new Error(
        'Aucune finition choisie, impossible de sauvegarder vos choix'
      );
    }

    if (config.currentEquipment?.id) {
      configsToSend[index].equipment = config.currentEquipment.id;
    } else {
      throw new Error(
        'Aucune equipment de choisit, impossible de sauvegarder vos choix'
      );
    }

    if (config.currentOptions.length > 0) {
      config.currentOptions.forEach((co, idx) => {
        configsToSend[index].options[idx] = {
          odooId: co.option.odooId,
          quantity: co.qty,
        };
      });
    }

    if (config.currentCustomProduct?.length > 0) {
      config.currentCustomProduct.forEach((co, idx) => {
        configsToSend[index].custom_products[idx] = {
          ...co,
          price: co.price,
          // price: co.price * 1.2, // TODODEV : prix custom
        };
      });
    } else {
      configsToSend[index].custom_products = [];
    }

    if (config.currentNegativeDefaultOptionModel.length > 0) {
      config.currentNegativeDefaultOptionModel.forEach((curNegDef, idx) => {
        configsToSend[index].negative_default_option_models[idx] = {
          odooId: curNegDef.option.odooId,
          quantity: curNegDef.quantity,
        };
      });
    }

    if (config.currentNegativeDefaultOptionFinishEquipment.length > 0) {
      config.currentNegativeDefaultOptionFinishEquipment.forEach(
        (curNegDef, idx) => {
          configsToSend[index].negative_default_options_finish_equipment[idx] =
            {
              odooId: curNegDef.option.odooId,
              quantity: curNegDef.quantity,
            };
        }
      );
    }
  });

  return configsToSend;
};
